<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Transaction Reprocess</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />
					<div class="row">
						<div class="col-lg-8">
							<form @submit.prevent="onSubmit" novalidate>
								<h2>Please review your payment detail</h2>
								<hr />
								<div class="form-group">
									<div class="row">
										<div class="col">
											<img :src="'/static/img/flags/my.png'" /> MYR
										</div>
										<div class="col text-right amnt-margin">
											<b>{{ vModel.SendAmount}}</b>
										</div>
										<div class="col">
											<img :src="'/static/img/flags/'+vModel.Beneficiary.FlagCode+'.png'" />
											{{vModel.PayoutCurrency}}
										</div>
										<div class="col text-right amnt-margin">
											<b>{{vModel.PayoutAmount}}</b>
										</div>
									</div>
								</div>
								<hr />
								<div class="form-group">
									<div class="row">
										<div class="col">Exchange Rate</div>
										<div class="col text-right">{{vModel.ExchangeRate}}</div>
									</div>
								</div>
								<div class="form-group">
									<div class="row">
										<div class="col">TransferFee</div>
										<div class="col text-right">MYR{{vModel.TransferFee}}</div>
									</div>
								</div>
								<div class="form-group" v-if="vModel.ShowPromoDiscount">
									<div class="row">
										<div class="col">Promotion Discount</div>
										<div class="col text-right">-MYR{{vModel.PromotionDiscount}}</div>
									</div>
								</div>
								<div class="form-group" v-if="vModel.ShowGST">
									<div class="row">
										<div class="col">GST({{vModel.GSTPercentage}}% of transfer fee)</div>
										<div class="col text-right">MYR{{vModel.GST}}</div>
									</div>
								</div>

								<div class="form-group">
									<div class="row">
										<div class="col">Deposited Amount</div>
										<div class="col text-right">
											<b>MYR{{vModel.DepositedAmount}}</b>
										</div>
									</div>
								</div>

								<div class="form-group m-t-lg" v-show="vModel.IsBonusLinkCardNeeded && 1==2">
									<div class="row">
										<div class="col-md-6">
											<label>BonusLinkCard Number</label>
											<input type="text" class="form-control" name="BonuslinkCardNumber"
												   autocomplete="off" v-model="vModel.BonusLinkCardNumber"
												   v-validate="'validateBonusLink'"
												   :class="{'input': true, 'is-danger': errors.has('BonuslinkCardNumber') }" />
											<div v-show="errors.has('BonuslinkCardNumber')" class="help is-danger">
												{{ errors.first('BonuslinkCardNumber') }}
											</div>
										</div>
										<div class="col-md-6 text-right">
											<a class="a-with-ul"
											   href="http://www.bonuslink.com.my/EN/MemberApplication.aspx"
											   target="_blank">Register Bonus Link</a>
										</div>
									</div>
								</div>

								<div class="form-group m-t-lg" v-show="!vModel.IsBonusLinkCardNeeded && 1==2">
									<div class="row">
										<div class="col-md-6">
											<label>BonusLinkCard Number.: {{vModel.BonusLinkCardNumber}}</label>
										</div>

										<div class="col-md-6 text-right">
											<a class="a-with-ul"
											   href="http://www.bonuslink.com.my/EN/MemberApplication.aspx"
											   target="_blank">Register Bonus Link</a>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-lg-6" v-if="(vModel.Beneficiary.CountryId == 2 || vModel.Beneficiary.CountryId == 23 || vModel.Beneficiary.CountryId == 251) && vModel.Beneficiary.ReceiverType == 'Business'">
										<div class="form-group">
											<label for>
												Document Reference No
												<span class="required">*</span>
											</label>
											<input type="text" class="form-control"
												   id="DocumentRefNo"
												   name="DocumentRefNo" autocomplete="off"
												   v-model="vModel.DocumentRefNo"
												   data-vv-as="Document Reference No"
												   v-validate="'required'"
												   v-only-text-number
												   :class="{'input': true, 'is-danger': errors.has('DocumentRefNo') }"
												   v-only-uppercase />
											<div v-show="errors.has('DocumentRefNo')"
												 class="help is-danger">
												{{ errors.first('DocumentRefNo') }}
											</div>
										</div>
									</div>
								</div>
								<br />
								<div class="form-card-forms">
									<div class="row">
										<div class="col-lg-6">
											<div class="form-group">
												<label>
													Purpose of Payment
													<span class="required">*</span>
												</label>
												<kendo-dropdownlist name='PaymentPurposeId' v-if="PaymentPurposeCollection!=null" class="form-control"
																	v-model="vModel.PaymentPurposeId" :data-text-field="'Text'" :data-value-field="'Id'"
																	:option-label="'Please Select Purpose of Payment'" :auto-bind="true" :data-source="PaymentPurposeCollection"
																	:data-value-primitive="true">
												</kendo-dropdownlist>
												<input type="hidden" v-model="vModel.PaymentPurposeId"
													   v-validate="'required'" data-vv-as="Purpose of Payment"
													   id="PaymentPurposeId" name="PaymentPurposeId" />
												<div v-show="errors.has('PaymentPurposeId')" class="help is-danger">
													{{ errors.first('PaymentPurposeId') }}
												</div>
											</div>
											<!-- eo form group -->
										</div>
										<div class="col-lg-6">
											<div class="form-group">
												<label>
													Source of Fund
													<span class="required">*</span>
												</label>
												<kendo-dropdownlist name='SourceOfFundId' v-if="SourceOfFundsCollection!=null" class="form-control"
																	v-model="vModel.SourceOfFundId" :data-text-field="'Text'" :data-value-field="'Id'"
																	:option-label="'Please Select Source of Fund'" :auto-bind="true" :data-source="SourceOfFundsCollection"
																	:data-value-primitive="true">
												</kendo-dropdownlist>
												<input type="hidden" v-model="vModel.SourceOfFundId"
													   v-validate="'required'" data-vv-as="Source of Fund"
													   id="SourceOfFundId" name="SourceOfFundId" />
												<div v-show="errors.has('SourceOfFundId')" class="help is-danger">
													{{ errors.first('SourceOfFundId') }}
												</div>
											</div>
											<!-- eo form group -->
										</div>
										<!-- eo col -->
									</div>
									<!-- eo row -->
									<div class="row">
										<!-- eo col -->
										<div class="col-lg-6"
											 v-if="vModel.Beneficiary.CountryId == 2 && (vModel.PaymentPurposeId == 10 ||vModel.PaymentPurposeId == 15) && PayoutModeId != '98' && PayoutModeId != '97'">
											<div class="form-group">
												<label>
													Description of Goods/Services
													<span class="required">*</span>
												</label>
												<!-- <div class="input-group mb-3"> -->
												<input type="text" class="form-control text-uppercase"
													   id="GoodsAndServicesDescription"
													   name="GoodsAndServicesDescription" autocomplete="off"
													   v-model="vModel.GoodsAndServicesDescription"
													   data-vv-as="Description of Goods/Services"
													   v-validate="'required'"
													   :class="{'input': true, 'is-danger': errors.has('GoodsAndServicesDescription') }"
													   v-only-uppercase />
												<div v-show="errors.has('GoodsAndServicesDescription')"
													 class="help is-danger">
													{{ errors.first('GoodsAndServicesDescription') }}
												</div>
												<!-- </div> -->
											</div>
											<!-- eo form group -->
										</div>
										<!-- eo col -->
									</div>
									<!-- eo row -->
									<div class="row">
										<!-- eo col -->
										<div class="col-lg-6"
											 v-if="vModel.SourceOfFundId == 10 && PayoutModeId != '98' && PayoutModeId != '97'">
											<div class="form-group">
												<label>
													Source of Fund
													<span class="required">*</span>
												</label>
												<input type="text" class="form-control text-uppercase"
													   id="SourceOfFundOthers" name="SourceOfFundOthers"
													   autocomplete="off" v-model="vModel.SourceOfFundOthers"
													   data-vv-as="Other source of fund"
													   v-validate="vModel.SourceOfFundId == 10 ? 'required' : ''"
													   :class="{'input': true, 'is-danger': errors.has('SourceOfFundOthers') }"
													   v-only-uppercase />
												<div v-show="errors.has('SourceOfFundOthers')"
													 class="help is-danger">
													{{ errors.first('SourceOfFundOthers') }}
												</div>
												<!-- </div> -->
											</div>
											<!-- eo form group -->
										</div>
										<!-- eo col -->
									</div>
								</div>
								<div class="form-card" v-if="vModel.IsSourceOfWealthNeeded">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label>
														Source of Wealth
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist name='SourceOfWealthId' v-if="SourceOfWealthCollection!=null" class="form-control"
																		v-model="vModel.SourceOfWealthId" :data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Source of Wealth'" :auto-bind="true" :data-source="SourceOfWealthCollection"
																		:data-value-primitive="true">
													</kendo-dropdownlist>
													<input type="hidden" v-model="vModel.SourceOfWealthId"
														   v-validate="'required'" data-vv-as="Source of wealth"
														   id="SourceOfWealthId" name="SourceOfWealthId" />

													<div v-show="errors.has('SourceOfWealthId')" class="help is-danger">
														{{ errors.first('SourceOfWealthId') }}
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
											<div class="col-lg-6" v-if="vModel.SourceOfWealthId == 11">
												<div class="form-group">
													<label>
														Source of Wealth Other
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<input type="text" class="form-control text-uppercase"
															   id="SourceOfWealthOthers" name="SourceOfWealthOthers"
															   autocomplete="off" v-model="vModel.SourceOfWealthOthers"
															   data-vv-as="Other source of wealth" v-validate="'required'"
															   :class="{'input': true, 'is-danger': errors.has('SourceOfWealthOthers') }"
															   v-only-uppercase />
														<div v-show="errors.has('SourceOfWealthOthers')"
															 class="help is-danger">
															{{ errors.first('SourceOfWealthOthers') }}
														</div>
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>
										<!-- eo row -->
									</div>
									<!-- eo form card forms -->
								</div>
								<br />
								<div class="form-group">
									<p>
										<label>
											<input name="termsandconditions" data-vv-as="Terms and Conditions"
												   v-validate="'required'" type="checkbox" />
										</label> I have read the Disclaimer & Accept all the <a href="https://www.eremit.com.my/privacy/personal"
																			target="_blank" style="color:#ff0000">
											Terms and
											Conditions.
										</a>
										<br />By clicking Confirm Reprocess below, I confirm that all the details above
										are correct and in order.
									</p>

									<div v-show="errors.has('termsandconditions')" class="help is-danger">
										{{ errors.first('termsandconditions') }}
									</div>
								</div>
								<hr />
								<div class="m-t-md">
									<button class="btn btn-danger" type="submit">Confirm Reprocess</button>

									<button type="button" class="btn btn-default" @click="onCancel">Cancel</button>
								</div>
							</form>
						</div>
						<!-- eo col-8 -->

						<div class="col-lg-4">
							<div class="sidebar">
								<img src="img/icons/arrow-down-indicator-white.png" alt class="sidebar-arrow" />

								<h3 class="sidebar-header">Ref Num : {{vModel.TransactionRefNumber}}</h3>

								<hr />

								<!-- <UserCountrySection/> -->
								<div class="country-detail">
									<img :src="'/static/img/flags/'+vModel.Beneficiary.FlagCode+'.png'" alt />
									<h4>
										{{vModel.Beneficiary.FullName}}
										<br />
										<span class="country">{{vModel.Beneficiary.Country}}</span>
									</h4>
								</div>
								<hr />

								<div class="personal-detail">
									<ul>
										<li>
											<p>Payment Mode :</p>
											<h4>
												{{
												vModel.PaymodeId == 1 ? "Bank Account"
												: (vModel.PaymodeId == 2) ? "Cash Pickup"
												: vModel.PaymodeId == 21 ? "Union Pay Card"
												: vModel.PaymodeId == 22 ? "Alipay"
												: vModel.PaymodeId == 23 ? "bKash"
												: (vModel.PaymodeId == 24 || vModel.PaymodeId == 28 || vModel.PaymodeId == 29) ? "eWallet"
												: vModel.PaymodeId == 26 ? "MCB"
												: vModel.PaymodeId == 27 ? "Weixin Wallet"
												: vModel.PaymodeId == 30 ? "Nagad Wallet"
												: (vModel.PaymodeId == 31) ? "ESEWA Wallet"
												: (vModel.PaymodeId == 32) ? "AYA Wallet"
												: (vModel.PaymodeId == 33) ? "KBZPay Wallet"
												: vmodel.PaymentModeName
												}}
											</h4>
										</li>
										<li v-if="vModel.PaymodeId == 1 && (vModel.Beneficiary.CountryId == 23 || vModel.Beneficiary.CountryId == 251 ||  vModel.Beneficiary.CountryId == 2) && vModel.Beneficiary.ReceiverType">
											<p>
												{{
												 "Receiver Type :"
												}}
											</p>
											<h4>
												{{vModel.Beneficiary.ReceiverType}}
											</h4>
										</li>
										<li>
											<p>
												{{
													vModel.PaymodeId == 1 ? "Bank Account Holder Name" :
													(vModel.PaymodeId == 2) ? "Beneficiary Name" :
													(vModel.PaymodeId == 27 || vModel.PaymodeId == 31 || vModel.PaymodeId == 32 || vModel.PaymodeId == 33) ? "Wallet Holder Name" :
													(vModel.PaymodeId == 28 || vModel.PaymodeId == 29) ? "eWallet Holder Name" :"Beneficiary Name"
												}}:
												<h4>
													{{vModel.Beneficiary.FirstName}} {{vModel.Beneficiary.MiddleName}}
													{{vModel.Beneficiary.LastName}}
												</h4>
</li>
										<li v-if="OnBehalfDetail.OnBehalfCustomerDetail != null">
											<p>Beneficial Owner :</p>
											<h4>{{OnBehalfDetail.OnBehalfCustomerDetail.Name}}</h4>
										</li>
										<!--<li v-else>
											<div v-if="vModel.OnBehalfCustomerDetail.OnBehalfCustomerId">
												<p>Beneficial Owner :</p>
												<h4>{{vModel.OnBehalfCustomerDetail.Name}}</h4>
											</div>
										</li>-->
										<li v-if="vModel.PaymodeId == 1">
											<p>
											   Bank Account Number :
											</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 1">
											<p>Bank Name :</p>
											<h4>{{vModel.Beneficiary.Bank}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 21">
											<p>Union Pay Card :</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 22  || vModel.PaymodeId == 31 || vModel.PaymodeId == 32 || vModel.PaymodeId == 33">
											<p>Wallet Number :</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 23">
											<p>bKash Wallet Number :</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 26">
											<p>MCB Wallet Number :</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 24">
											<p>eWallet Type :</p>
											<h4>{{vModel.Beneficiary.Bank}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 28 || vModel.PaymodeId == 29">
											<p>eWallet Type :</p>
											<h4>{{vModel.Beneficiary.WalletType}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 28 || vModel.PaymodeId == 29">
											<p>eWallet Number :</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 24">
											<p>eWallet Number :</p>
											<h4>{{vModel.Beneficiary.BankAccount}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 2 || vModel.PaymodeId == 34 || vModel.PaymodeId == 35">
											<p>Agent :</p>
											<h4>{{vModel.Beneficiary.Agent}}</h4>
										</li>
										<li v-if="vModel.PaymodeId == 2">
											<p>Address :</p>
											<h4>{{vModel.Beneficiary.Address}}</h4>
										</li>
									</ul>
								</div>

								<hr />

								<div class="amount-detail">
									<ul>
										<li>
											Exchange Rate :
											<span>{{vModel.ExchangeRate}}</span>
										</li>
										<li>
											Transfer Fee :
											<span>{{vModel.TransferFee}}</span>
										</li>
										<li v-if="vModel.ShowGST">
											GST ({{vModel.GSTPercentage}}% of transfer fee) :
											<span>{{vModel.GST}}</span>
										</li>
										<li v-if="vModel.ShowPromoDiscount">
											Promotion Discount (MYR):
											<span>-{{vModel.PromotionDiscount}}</span>
										</li>
									</ul>

									<div class="total-detail">
										<h4>Deposited Amount</h4>
										<p>MYR {{vModel.DepositedAmount}}</p>
									</div>
								</div>
							</div>
						</div>

						<!--<div class="col-lg-4">


										<div class="sidebar">
											<h2>Recipient</h2>
											<hr />
											<div class="form-group">{{vModel.Beneficiary.FirstName}} {{vModel.Beneficiary.MiddleName}} {{vModel.Beneficiary.LastName}}</div>
											<div v-if="vModel.PaymodeId == 1">
												<h4>
													Bank: {{vModel.Beneficiary.Bank}}<br />
													A/C No.: {{vModel.Beneficiary.BankAccount}}
												</h4>
											</div>
											<div v-else-if="vModel.PaymodeId == 21">
												<h4>
													Union Pay Card: {{vModel.Beneficiary.BankAccount}}
												</h4>
											</div>
											<div v-else="">
												<h4>
													Agent: {{vModel.Beneficiary.Agent}}
													<br />
													Address:
												</h4>
											</div>
										</div>

						</div>-->
					</div>
					<!-- eo row -->
				</div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import Base from "../../shared/Base.vue";
	import UserCountrySection from "../../shared/UserCountrySection.vue";

	import ListService from "../../services/list";
	import TransactionService from "../../services/transaction";
	import CommonService from "../../services/common";

	export default {
		name: "TransactionReprocess",
		extends: Base,
		components: { UserCountrySection },
		created() {
			var onbehalf = CommonService.getStorage("BeneOwnerDetail");
			if (onbehalf)
				this.OnBehalfDetail = CommonService.getStorage("BeneOwnerDetail");
		},

		beforeRouteEnter(to, from, next) {
			var promises = [];
			promises.push(
				TransactionService.getDetailDuringReprocess(
					to.params.txnrefno,
					  to.params.onbehalfid ? to.params.onbehalfid : '00000000-0000-0000-0000-000000000000'
				)
			);
			if (to.params.onbehalfid != null) {
				promises.push(ListService.get("onbehalf/customer/init/" + to.params.onbehalfid));
			}
			Promise.all(promises).then(response => {
				next(p => {
					var res = response[0].body;
					p.vModel = res;
					p.vModel.DocumentRefNo = res.DocumentRefNumber;
					p.OnBehalfCustomerId = to.params.onbehalfid;

					p.PaymentPurposeCollection = res.PayPurposes;
					p.SourceOfFundsCollection = res.SourceOfFunds;
					p.SourceOfWealthCollection = res.SourceOfWealths;

					if (to.params.onbehalfid != null) {
						p.OnBehalfDetail = response[1].body;
					}
				});
			});
		},
		data() {
			return {
				OnBehalfCustomerId: null,
				OnBehalfDetail: {
					OnBehalfCustomerId: null
				},
				vModel: {
					PayoutAmount: null,
					SendAmount: null,
					TransactionRefNumber: null,
					CreatedDate: null,
					TransactionStatus: null,
					IsReprocess: false,
					IsRefundEnabled: false,
					PaymodeId: null,
					Remark: null,
					SourceOfFund: null,
					PaymentPurpose: null,
					ExchangeRate: null,
					TransferFee: null,
					GST: null,
					ShowGST: true,
					DepositedAmount: null,
					PaymentProgressList: null,
					PaymentProgressComment: null,
					GSTPercentage: null,
					PayoutCurrency: null,
					FPXNumber: null,
					IsBonusLinkCardNeeded: false,
					BonusLinkCardNumber: null,
					DocumentRefNo: null,
					Beneficiary: {
						Id: null,
						FirstName: null,
						MiddleName: null,
						LastName: null,
						CountryCode: null,
						Country: null,
						Currency: null,
						City: "",
						Street: "",
						PostCode: null,
						State: null,
						Bank: null,
						BankAccount: null,
						Agent: null,
						CashPickupPin: null,
						ReasonRemark: "",
						RefundAmount: null,
						FlagCode: null,
						IsBonusLinkCardNeeded: false,
						ReceiverType: null
					},

					SourceOfFundId: null,
					PaymentPurposeId: null,
					SourceOfWealthId: null,
				},
				PaymentPurposeCollection: null,
				SourceOfFundsCollection: null,
				SourceOfWealthCollection: null
			};
		},

		methods: {
			onSubmit: function () {
				var self = this;
				if (self.isProcessing) return false;

				self.$validator.validateAll().then(result => {
					if (result) {
						self.isProcessing = true;

						TransactionService.reprocess({
							TransactionRefNo: self.vModel.TransactionRefNumber,
							BonuslinkCardNumber: self.vModel.BonuslinkCardNumber,
							OnBehalfCustomerId: self.OnBehalfCustomerId == null ? self.vModel.OnBehalfCustomerDetail.OnBehalfCustomerId : self.OnBehalfCustomerId,
							DocumentRefNumber: self.vModel.DocumentRefNo,

							SourceOfFundId: self.vModel.SourceOfFundId,
							PaymentPurposeId: self.vModel.PaymentPurposeId,
							SourceOfWealthId: self.vModel.SourceOfWealthId,
						}).then(
							res => {
								if (res.body.Success) {
									self.$toastr("success", "Transaction reprocessed successfully");
									self.$router.push(
										"/transaction/detail/" + res.body.TransactionRefNo
									);
								} else
									self.$toastr(
										"info",
										"Please contact  customer care or try again ."
									);

								self.isProcessing = false;
							},
							err => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			onCancel: function () {
				this.$router.push("/transaction");
			}
		}
	};
</script>

<style scopped>
	.amnt-margin {
		margin-top: 5px;
	}
</style>
